import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {TextLink} from '@/common/components/TextLink';
import forecaLogo from '@/common/styles/img/foreca.svg?file';
import styles from './AppFooter.css';

export const AppFooter: FC = () => {
	const t = useLocalizer();

	const currentYear = new Date().getFullYear().toString();

	return (
		<footer className={styles.root}>
			<p className={styles.info}>
				{t('copyright', {domain: DOMAIN_NAME, currentYear})} {t('partners')}{' '}
				<img className={styles.forecaLogo} src={forecaLogo} alt='FORECA logo' />
			</p>
			<p>
				<TextLink className={styles.link} href='/agreement' target='_blank'>
					{t('termsAgreement')}
				</TextLink>
				<TextLink className={styles.link} href='/privacypolicy' target='_blank'>
					{t('privacyAgreement')}
				</TextLink>
				<TextLink className={styles.link} href={`/feedback?skin=informer&lang=${t.language}`} target='_blank'>
					{t('sendGeneralFeedback')}
				</TextLink>
				<TextLink
					className={styles.link}
					href={`/feedback?skin=informer&lang=${t.language}&mode=ads`}
					target='_blank'>
					{t('sendAdQuestion')}
				</TextLink>
			</p>
		</footer>
	);
};

AppFooter.displayName = 'AppFooter';
